import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { MyAxios } from 'services/SettingAxios';
import type { AxiosRequestConfig, AxiosError } from 'axios';
import config from '@app/config';
import { ServiceCookies } from '@services/ServiceCookies';

export interface PromiseAxiosBaseQuery {
  url: string;
  method: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
}

export function defaultHeaders(headers) {
  headers.set('Accept', 'application/json');
  headers.set('content-type', 'application/json');
  headers.set('Authorization', `Bearer ${config.apiToken}`);
  headers.set(ServiceCookies.KEY, ServiceCookies.sessionId);
  return headers;
}

export const axiosBaseQuery =
  (): BaseQueryFn<PromiseAxiosBaseQuery, unknown, unknown> =>
  async ({ url, method, data, params }) => {
    try {
      const result = await MyAxios({ url, method, data, params });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
